import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
} from '@angular/core';
import {
  buildFipeComparison,
  buildFipeComparisonFromDiff,
  FipeComparisonDigits,
  FipeComparisonModeInput,
  getFipeComparisonColor,
} from '@app-utils/fipe-comparison.utils';

export type FipeComparisonBadgeVariant = 'tag' | 'overlay' | 'inline';

@Component({
  selector: 'app-fipe-comparison-badge',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './fipe-comparison-badge.component.html',
  styleUrls: ['./fipe-comparison-badge.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FipeComparisonBadgeComponent {
  readonly price = input<number | null | undefined>(undefined);
  readonly fipePrice = input<number | null | undefined>(undefined);
  readonly fipeDiff = input<number | null | undefined>(undefined);
  readonly displayMode = input<FipeComparisonModeInput>(undefined);
  readonly digits = input<FipeComparisonDigits>('1.0-0');
  readonly variant = input<FipeComparisonBadgeVariant>('inline');
  readonly cssClass = input<string>('');
  readonly shortLabel = input<boolean>(false);
  readonly accentColor = input<string>('#16B097');
  readonly hideIfAboveFipe = input<boolean>(false);

  readonly viewModel = computed(() => {
    const price = this.price();
    const fipePrice = this.fipePrice();
    const fipeDiff = this.fipeDiff();
    const mode = this.displayMode();
    const digits = this.digits();

    let comparison = null;

    if (price != null && fipePrice != null) {
      comparison = buildFipeComparison(price, fipePrice, mode, digits);
    } else if (fipeDiff != null) {
      comparison = buildFipeComparisonFromDiff(fipeDiff, mode, digits);
    }

    if (comparison && this.hideIfAboveFipe() && comparison.isAboveFipe) {
      return null;
    }

    return comparison;
  });

  readonly color = computed(() => {
    const vm = this.viewModel();
    if (!vm) {
      return undefined;
    }

    return getFipeComparisonColor(vm.isAboveFipe, this.accentColor());
  });

  readonly displaySuffix = computed(() => {
    if (!this.viewModel()?.suffix) {
      return '';
    }

    return this.shortLabel() ? 'FIPE' : 'da FIPE';
  });
}
